// Generated by purs version 0.15.10
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Control_Monad_Reader_Trans from "../Control.Monad.Reader.Trans/index.js";
import * as Control_Monad_State_Trans from "../Control.Monad.State.Trans/index.js";
import * as Control_Monad_Trans_Class from "../Control.Monad.Trans.Class/index.js";
import * as Data_UUID_Random from "../Data.UUID.Random/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Random from "../Effect.Random/index.js";
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Effect_Aff.monadEffectAff);
var lift = /* #__PURE__ */ Control_Monad_Trans_Class.lift(Control_Monad_Except_Trans.monadTransExceptT);
var lift1 = /* #__PURE__ */ Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT);
var lift2 = /* #__PURE__ */ Control_Monad_Trans_Class.lift(Control_Monad_State_Trans.monadTransStateT);
var monadRandomAff = {
    chooseInt: function (a) {
        return function (b) {
            return liftEffect(Effect_Random.randomInt(a)(b));
        };
    },
    Monad0: function () {
        return Effect_Aff.monadAff;
    }
};
var chooseInt = function (dict) {
    return dict.chooseInt;
};
var randomUUIDv4 = function (dictMonadRandom) {
    return Data_UUID_Random["make$prime"]((dictMonadRandom.Monad0()).Applicative0())(chooseInt(dictMonadRandom));
};
var monadRandomExceptT = function (dictMonadRandom) {
    var Monad0 = dictMonadRandom.Monad0();
    var lift3 = lift(Monad0);
    var chooseInt1 = chooseInt(dictMonadRandom);
    var monadExceptT = Control_Monad_Except_Trans.monadExceptT(Monad0);
    return {
        chooseInt: function (a) {
            return function (b) {
                return lift3(chooseInt1(a)(b));
            };
        },
        Monad0: function () {
            return monadExceptT;
        }
    };
};
var monadRandomReaderT = function (dictMonadRandom) {
    var Monad0 = dictMonadRandom.Monad0();
    var lift3 = lift1(Monad0);
    var chooseInt1 = chooseInt(dictMonadRandom);
    var monadReaderT = Control_Monad_Reader_Trans.monadReaderT(Monad0);
    return {
        chooseInt: function (a) {
            return function (b) {
                return lift3(chooseInt1(a)(b));
            };
        },
        Monad0: function () {
            return monadReaderT;
        }
    };
};
var monadRandomStateT = function (dictMonadRandom) {
    var Monad0 = dictMonadRandom.Monad0();
    var lift3 = lift2(Monad0);
    var chooseInt1 = chooseInt(dictMonadRandom);
    var monadStateT = Control_Monad_State_Trans.monadStateT(Monad0);
    return {
        chooseInt: function (a) {
            return function (b) {
                return lift3(chooseInt1(a)(b));
            };
        },
        Monad0: function () {
            return monadStateT;
        }
    };
};
export {
    chooseInt,
    randomUUIDv4,
    monadRandomStateT,
    monadRandomExceptT,
    monadRandomReaderT,
    monadRandomAff
};
